<template>
    <card>
        <div class="row" v-if="teammate">
            <div class="col-sm-6">
                
                <user :user="session.instructor"
                    :handler="openInstructor"
                    :subtitle="$t('common.instructor')"
                    :vertical="!compact"
                     v-if="instructorClickable(session.instructor)">
                </user>

                <user :user="session.instructor"
                    :subtitle="$t('common.instructor')"
                    :vertical="!compact"
                    v-else>
                </user>
            </div>
            <div class="col-sm-6">
                
                <user :user="teammate"
                    :handler="openOrEditTeammate"
                    :subtitle="$t('sessions.teammate')"
                    :vertical="!compact"
                     v-if="teammate.state && (teammate.state.published || $permissions.hasRight('dashboard.learners.write'))">
                </user>
                
                <user :user="teammate"
                    :handler="updateTeammate"
                    :subtitle="$t('sessions.teammate') + '<br>' + $t('sessions.add-teammate-notice')"
                    :vertical="!compact"
                     v-else-if="teammate.id == session.teammate_id && $permissions.hasRight('dashboard.learners.write')">
                </user>

                <user :user="teammate"
                    :subtitle="$t('sessions.teammate')"
                    :vertical="!compact"
                    v-else>
                </user>
            </div>
        </div>
        <div class="row align-items-center" v-else-if="edit && $permissions.hasRight('dashboard.learners.write')">
            <div class="col-sm-6">
                
                <user :user="session.instructor"
                    :handler="openInstructor"
                    :subtitle="$t('common.instructor')"
                    :vertical="!compact"
                     v-if="instructorClickable(session.instructor)">
                </user>

                <user :user="session.instructor"
                    :subtitle="$t('common.instructor')"
                    :vertical="!compact"
                    v-else>
                </user>
            </div>
            <div class="col-sm-6 text-center align-items-center">
                <base-button type="primary" size="sm" @click="updateTeammate">
                    {{ $t('sessions.add-teammate') }}
                </base-button>
                <small class="d-block mt-2">{{ $t('sessions.add-teammate-notice') }}</small>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">

                <user :user="session.instructor"
                    :handler="openInstructor"
                    :subtitle="$t('common.instructor')"
                    :vertical="!compact"
                     v-if="instructorClickable(session.instructor)">
                </user>

                <user :user="session.instructor"
                    :subtitle="$t('common.instructor')"
                    :vertical="!compact"
                    v-else>
                </user>
            </div>
        </div>

        <portal to="modals" v-if="edit">

            <form-modal v-model="ctrl.modals.edit" size="sm"
                :title="$t('sessions.teammate')"
                :loading="ctrl.form.loading"
                body-classes="px-lg-4 pt-0"
                backdrop='true'
                :centered="false"
            >
                <teammate-form v-model="ctrl.form.data"
                    :errors="ctrl.form.errors"
                    :modal="ctrl.modals.edit"
                    :learners="freeLearners"
                >
                </teammate-form>
            </form-modal>
        </portal>
    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import User from '../common/User'
    import TeammateForm from './TeammateForm'

    export default {

        components: {
            User, TeammateForm,
        },
        
        props: {

            learner: {
                type: Object,
                required: true
            },

            learners: {
                type: Array,
                default: []
            },

            session: {
                type: Object,
                required: true
            },

            edit: {
                type: Boolean,
                default: false
            },

            compact: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/dashboard/sessions',
                    query: {
                        registration_id: this.session.registration_id,
                        simulation_id: this.session.simulation_id,
                    },
                    autolist: false,
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    callbacks: {
                        updated: this.teammateUpdated,
                    }
                }),
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl')
        },

        computed: {

            freeLearners() {
                return this.learners.filter(learner => learner.id != this.learner.id)
            },

            teammate() {
                if (this.learner.id == this.session.learner1_id && this.session.learner2) {
                    return this.session.learner2
                }
                if (this.learner.id == this.session.learner2_id && this.session.learner1) {
                    return this.session.learner1
                }
                if (this.session.teammate) {
                    return this.session.teammate
                }
                return null
            }
        },

        methods: {

            instructorClickable(instructor) {
                return instructor.id == this.$auth.user.id && this.$permissions.hasRight('dashboard.learners.write')
            },

            openOrEditTeammate() {
                if (this.teammate.state.published) {
                    this.openTeammate()
                } else {
                    this.editTeammate()
                }
            },

            openTeammate() {
                this.$router.push({ name: 'dashboard-learner-simulation',
                    params: { 
                        learnerId: this.teammate.id,
                        registrationId: this.session.registration_id,
                        simulationId: this.session.simulation_id,
                    }
                })
            },

            editTeammate() {
                this.$router.push({ name: 'dashboard-learner-simulation-edit',
                    params: { 
                        learnerId: this.teammate.id,
                        registrationId: this.session.registration_id,
                        simulationId: this.session.simulation_id,
                    }
                })
            },

            openInstructor() {
                this.$router.push({ name: 'log-session-summary',
                    params: { 
                        sessionId: this.session.id,
                        registrationId: this.session.registration_id,
                        simulationId: this.session.simulation_id,
                        groupId: 0,
                    }
                })
            },

            updateTeammate() {
                this.ctrl.update(this.session.id)
            },

            teammateUpdated(resp) {
                this.$emit('updated', resp.data.data)
            },

            mapData(session) {
                return {
                    id: session ? session.id : null,
                    instructor: session ? session.instructor : null,
                    learner1: session ? session.learner1 : null,
                    learner2: session ? session.learner2 : null,
                    teammate: session ? session.teammate : null,
                    learner1_id: session ? session.learner1_id : null,
                    learner2_id: session ? session.learner2_id : null,
                    teammate_id: session ? session.teammate_id : null,
                    created_at: session ? session.created_at : null,
                    started_at: session ? session.started_at : null,
                    ended_at: session ? session.ended_at : null,
                    closed_at: session ? session.closed_at : null,
                    registration_id: session ? session.registration_id : null,
                    simulation_id: session ? session.simulation_id : null,
                }
            },

            unmapData(data) {
                delete data.instructor
                delete data.learner1
                delete data.learner2
                delete data.teammate
                return data
            },
        }
    }
</script>
